var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-problems"},[_c('benefit',{attrs:{"benefit-content":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }